<template>
  <div>
    <b-message>
      Leaderboard for <b>{{gameName}}</b>
    </b-message>
    <leaderboard-table
      ref="leaderBoardChild"
      :isBase64ImageRequired="false"
    ></leaderboard-table>
    <button
      class="button is-light btn-margin"
      @click.prevent="cancel()"
    >
      Back to games list
    </button>
    <button @click.prevent="refreshScores()" class="button is-primary" style="margin-left: 5px;">Refresh scores</button>
  </div>
</template>

<script>
  import LeaderboardTable from './single/LeaderboardTable'

  export default {
    components: {LeaderboardTable},
    name: 'leaderboard',
    data() {
      return {
        gameName: this.$route.params.name,
      }
    },
    methods: {
      cancel() {
        this.$router.go(-1)
      },
      refreshScores() {
        this.$refs.leaderBoardChild.loadTeamLeaderboard()
      },
    }
  }
</script>

<style scoped>

</style>
